// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SkillEvaluation_wrapper__2EZ1Y","skill_name":"SkillEvaluation_skill_name__2pNjN","icon":"SkillEvaluation_icon__1BKOA","year_input":"SkillEvaluation_year_input__dNJes"};